import React from "react";
import {withNamespaces} from "react-i18next";

import {
    useCookieConsent,
} from "../../../../cookie-consent/provider";
import DecorativeFleetMap from "./DecorativeFleetMap";
import "./style.less";

function TruckIcon() {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
        >
            <path
                d="M3.5 6.5H14.5V16.5H3.5V6.5Z"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinejoin="round"
            />
            <path
                d="M14.5 10H18L20.5 13V16.5H14.5V10Z"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinejoin="round"
            />
            <circle
                cx="7"
                cy="17.5"
                r="1.5"
                stroke="currentColor"
                strokeWidth="1.6"
            />
            <circle
                cx="17.5"
                cy="17.5"
                r="1.5"
                stroke="currentColor"
                strokeWidth="1.6"
            />
        </svg>
    );
}

function RoutesMapSection({t, i18n}) {
    const {
        isFunctionalEnabled,
        openSettings,
    } = useCookieConsent();

    return (
        <section className="landing-routes-map landing-section landing-section--middle">
            <div className="container public-site-shell">
                <div className="landing-routes-map__heading landing-section-heading">
                    <div>
                        <span className="landing-routes-map__eyebrow landing-section-heading__eyebrow">
                            {t("main.landing.routesMap.eyebrow")}
                        </span>

                        <h2 className="landing-routes-map__title landing-section-heading__title">
                            {t("main.landing.routesMap.title")}
                        </h2>
                    </div>

                    <p className="landing-routes-map__intro landing-section-heading__intro">
                        {t("main.landing.routesMap.intro")}
                    </p>
                </div>

                <div className="landing-routes-map__card">
                    <div className="landing-routes-map__badge">
                        <TruckIcon/>
                        <span>
                            {t("main.landing.routesMap.demoLabel")}
                        </span>
                    </div>

                    {isFunctionalEnabled ? (
                        <DecorativeFleetMap
                            ariaLabel={t(
                                "main.landing.routesMap.mapAriaLabel"
                            )}
                            balloonLabels={t(
                                "main.landing.routesMap.balloon",
                                {
                                    returnObjects: true,
                                }
                            )}
                            language={i18n.language}
                            vehicleHint={t(
                                "main.landing.routesMap.vehicleHint"
                            )}
                        />
                    ) : (
                        <div className="landing-routes-map__consent">
                            <span className="landing-routes-map__consent-icon">
                                <TruckIcon/>
                            </span>

                            <h3>
                                {t(
                                    "main.landing.routesMap.consentTitle"
                                )}
                            </h3>

                            <p>
                                {t(
                                    "main.landing.routesMap.consentDescription"
                                )}
                            </p>

                            <button
                                type="button"
                                onClick={openSettings}
                            >
                                {t(
                                    "main.landing.routesMap.consentAction"
                                )}
                            </button>
                        </div>
                    )}

                    {isFunctionalEnabled && (
                        <div className="landing-routes-map__hint">
                            {t("main.landing.routesMap.controlsHint")}
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
}

export default withNamespaces("translation")(
    RoutesMapSection
);
